<template>
  <div id="lock-timer" class="lock-timer">
    <div class="d-flex">
      <div class="px-2">
        <img class="profile-picture" :src="profilePictureUrl" alt="Profil" />
      </div>
      <div class="d-grid gap-1">
        <div class="user-name">
          {{ user.fullName || user.userName }}
        </div>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <count-down
            :time="Number(lockTimeout)"
            :transform="transform"
            @progress="handleCountdownProgress"
            ref="countdown"
            @end="lockUser"
            :key="key"
          >
            <template slot-scope="props">
              <div class="refresh-time">{{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}</div>
            </template>
          </count-down>
          <div>
            <span
              @click="refreshTimeout"
              role="button"
              class="text-white hand material-icons refresh-icon md-18"
              :title="$i18n.t('refresh_timeout')"
            >
              sync
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import core from '../../utils/mixin-core'
import mixinNotify from '../../utils/mixin-notify'
import CountDown from '@chenfengyuan/vue-countdown'
import { LOGOUT_UI_TIMEOUT } from '../../consts'
import axios from '../../axiosClient'
import AuthProvider from '../../lib/auth/provider'

/* 30*60*1000 */
const USER_LOCK_TIMEOUT = 1800000

/**
 * @class LockTimer
 *
 * @description idozito komponens automatikus kijelentkezeshez
 */
export default {
  name: 'LockTimer',
  mixins: [core, mixinNotify],
  components: {
    CountDown,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    lockUrl: {
      type: String,
      default: `/logout`,
    },
    warningTimeout: {
      type: Number,
      default: 59000,
    },
  },
  data() {
    return {
      lockTimeout: this.getDefaultLockTimeout(),
      key: 0,
      warningHours: 0,
      warningMinutes: 0,
      warningSeconds: 0,
      countDownTime: 0,
      activityWatcherTime: 60000,
      cursorPosition: { x: 0, y: 0 },
      isSnapShotTaken: false,
      activityEvents: ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'],
    }
  },
  computed: {
    profilePictureUrl() {
      return this.user.profilePicture ? `/download/${this.user.profilePicture}` : '/static/avatar.png'
    },
  },
  methods: {
    getDefaultLockTimeout() {
      return window?.CORE?.userLockTimeout ?? USER_LOCK_TIMEOUT
    },
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value
        props[key] = `${digits}`
      })
      return props
    },
    handleCountdownProgress(data) {
      if (
        data.hours === this.warningHours &&
        data.minutes === this.warningMinutes &&
        data.seconds === this.warningSeconds
      ) {
        const noti = {
          duration: 0,
          title: this.$i18n.t('Timeout_expires'),
          type: 'warning',
          text: this.$i18n.t('Timeout_expires_soon_click_to_reset'),
          onClick: this.resetTimeout,
          customClass: 'notification__cursor-pointer',
          save: false,
        }
        this.showNotification(noti)
      }
      this.countDownTime = data.totalMilliseconds
    },
    /**
     * @description kijelentkezes
     */
    async logout() {
      await axios()
        .get(this.lockUrl)
        .catch((error) => {
          console.error('axios error', error)
        })
      const authenticator = AuthProvider.getAuthenticator()
      return authenticator.logout()
    },
    /**
     * @description idozito ujrainditasa
     */
    async refreshTimeout() {
      if (window.CORE.socket) {
        window.CORE.socket.emit('refreshLockTimeout', {
          userId: window.CORE.params.ID_S_USER,
        })
      } else {
        const authenticator = AuthProvider.getAuthenticator()
        await authenticator.refreshToken()
        this.resetTimeout()
      }
    },
    /**
     * @description idokorlat megujitasa es a komponens frissitese
     */
    resetTimeout() {
      this.lockTimeout = this.getDefaultLockTimeout()
      this.key++
      this.$notify.closeAll()
    },
    /**
     * @description felhasznalo kijelentkeztetse uzenet kuldese vagy logout url hivasa
     */
    lockUser() {
      if (window.CORE.socket) {
        window.CORE.socket.emit('userLogout', {
          system: window.CORE.params.ID_SUBSYSTEM,
          userId: window.CORE.params.ID_S_USER,
        })
      } else {
        this.logout()
      }
    },
    watchCountDownProgress(event) {
      if (this.countDownTime < event.time) {
        this.lockTimeout = event.time
        this.key++
      }
    },
    logoutUser() {
      setTimeout(() => {
        this.logout()
      }, LOGOUT_UI_TIMEOUT)
    },
    registerEventListeners() {
      if (this.CORE && this.CORE.socket) {
        this.CORE.socket.addEventListener('refreshLockTimeout', this.resetTimeout)
        this.CORE.socket.addEventListener('watchCountDownProgress', this.watchCountDownProgress)
        this.CORE.socket.addEventListener('userLogout', this.logoutUser)
      }

      this.activityEvents.forEach((eventName) => document.addEventListener(eventName, this.checkCursorPosition))
    },
    setMenuWidth() {
      const maxWidth = 500
      const minWidth = 200
      const width = `${this.user.fullName.length * 9 + 115}px`
      const lockTimer = document.querySelector('#lock-timer')
      if (lockTimer) {
        lockTimer.style.width = width < minWidth ? minWidth : width > maxWidth ? maxWidth : width
      }
    },
    checkCursorPosition(event) {
      if (
        this.needNewSnapshot &&
        (this.cursorPosition.x !== event.clientX || this.cursorPosition.y !== event.clientY)
      ) {
        this.cursorPosition.x = event.clientX
        this.cursorPosition.y = event.clientY
        this.needNewSnapshot = false
        this.refreshTimeout()
      }
    },
    setCursorSnapshotSwitch() {
      this.intervalTimer = setInterval(() => (this.needNewSnapshot = true), this.activityWatcherTime)
      window.CORE.intervalTimers.push(this.intervalTimer)
    },
    emitWatchCountDownProgressEvent() {
      if (window.CORE && window.CORE.socket) {
        window.CORE.socket.emit('watchCountDownProgress', {
          userId: window.CORE.params.ID_S_USER,
          time: this.countDownTime,
        })
      }
    },
    setWarningTimeouts() {
      this.warningSeconds = Math.floor(this.warningTimeout / 1000)
      this.warningMinutes = Math.floor(this.warningSeconds / 60)
      this.warningHours = Math.floor(this.warningMinutes / 60)
    },
    removeEventListeners() {
      if (this.CORE && this.CORE.socket) {
        this.CORE.socket.removeEventListener('refreshLockTimeout', this.resetTimeout)
        this.CORE.socket.removeEventListener('watchCountDownProgress', this.watchCountDownProgress)
        this.CORE.socket.removeEventListener('userLogout', this.logoutUser)
      }

      this.activityEvents.forEach((eventName) => document.removeEventListener(eventName, this.checkCursorPosition))
    },
  },
  mounted() {
    this.registerEventListeners()
    this.emitWatchCountDownProgressEvent()
    this.setMenuWidth()
    this.setCursorSnapshotSwitch()
  },
  /**
   * @description komponens inicializalasa
   */
  created() {
    this.refreshTimeout()
    this.setWarningTimeouts()
  },
  beforeDestroy() {
    clearInterval(this.intervalTimer)
    this.removeEventListeners()
  },
}
</script>

<style scoped>
.lock-timer {
  padding: 15px 20px;
}

.profile-picture {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: fill;
}

.hand {
  cursor: pointer;
}

.refresh-icon {
  font-size: 10px;
}

.user-name {
  font-weight: 600;
}
</style>
